import { useDropdown } from '@/common/hooks/useDropdown';
import { usePathname } from 'next/navigation';
import { useCallback, useEffect } from 'react';

export const useHeader = () => {
  // const [{
  //   hasBeenOffline, isOnline, isPageLoading
  // }] = useAppContext()
  const pathname = usePathname();

  const {
    elementRef: searchRef,
    expanded: isSearchOpen,
    setExpanded: setIsSearchOpen,
    triggerRef: searchTriggerRef,
  } = useDropdown();

  useEffect(() => {
    setIsSearchOpen(false);
  }, [pathname, setIsSearchOpen]);

  const handleSearchTriggerClick = useCallback(() => {
    setIsSearchOpen(isOpen => !isOpen);
  }, [setIsSearchOpen]);

  return {
    handleSearchTriggerClick,
    // hasBeenOffline,
    // isOnline,
    // isPageLoading,
    isSearchOpen,
    setIsSearchOpen,
    searchRef,
    searchTriggerRef,
  };
};
